export const HITESH_SIR = require('../asstes/images/hiteshSir.jpg')
export const PIYUSH_SIR = require('../asstes/images/piyushSir.jpeg')
